import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';

import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Events")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [true ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      to: _vm.goToAdd()
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add event ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.gettingEvents.numberOfEvents
    }
  })], 1)])]), _c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.headers,
      items: _vm.gettingEvents.items,
      "item-key": "id_user",
      "items-per-page": _vm.formSearch.paging.limits,
      loading: _vm.gettingEvents.loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.date",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.date)) + " ")];
      }
    }, {
      key: "item.isPublicVisible",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.isPublicVisible ? _c("span", {
          staticClass: "text-green"
        }, [_vm._v("Yes")]) : _c("span", {
          staticClass: "text-red"
        }, [_vm._v("No")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.goToEventPage(item)
          }
        }, [_vm._v("Edit")]), item.isPublicVisible ? _c("span", {
          staticClass: "router-link",
          attrs: {
            to: "#"
          },
          on: {
            click: function click($event) {
              _vm.openUrl(_vm.getUniqueEventUrl(item));
            }
          }
        }, [_vm._v(" View event page ")]) : _vm._e()], 1)];
      }
    }])
  }), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.gettingEvents.numberOfPages,
      currentPage: _vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.gettingEvents.numberOfEvents
    }
  })], 1)])]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };